export default __webpack_public_path__ + "static/logo-small-6ee592ca6a35fdc112f7b0899ac11182.png";